// extracted by extract-css-chunks-webpack-plugin
module.exports = {"address":"address___228uJ"};